import React from 'react';
import {
  getEnterpriseCalendarLink,
  type GetEnterpriseCalendarLinkResponse
} from '../../common/api-client';
import useAPI, { type State } from '../../common/hooks/useAPI';

const useEnterpriseCalendarLink = (
  token: string,
  enterprise_id: string | null
): State<GetEnterpriseCalendarLinkResponse> => {
  const dataLoader = React.useCallback(
    () => getEnterpriseCalendarLink(token, enterprise_id),
    [token, enterprise_id]
  );
  return useAPI(dataLoader);
};

export default useEnterpriseCalendarLink;
